import React from 'react';

import { useAppSelector } from '@src/core/hooks';
import { cartSetCouponErrorsSelector } from '@src/features/cart/store/cart';
import { SaleConfirmation } from '@src/features/orders/legacy/SaleConfirmation';
import { checkoutErrorsSelector } from '@src/stores/checkout';

import { CheckoutStepSkeleton } from './CheckoutSkeleton';

/**
 * `SaleConfirmation` owns turning the cart into an order and has to stay mounted for that effect
 * to run, so it can't just be swapped out for the skeleton. Instead this shows the same skeleton
 * on top while `SaleConfirmation` works (hidden, not unmounted — its effect still fires) and only
 * reveals its own content once there is an error the buyer has to act on.
 */
export const CheckoutConfirmSaleStep = () => {
  const couponErrors = useAppSelector(cartSetCouponErrorsSelector);
  const checkoutErrors = useAppSelector(checkoutErrorsSelector);
  const hasError = Boolean(couponErrors?.length) || Boolean(checkoutErrors?.length);

  return (
    <div data-testid='checkout-confirm-sale-step'>
      {hasError ? null : <CheckoutStepSkeleton />}
      <div hidden={!hasError}>
        <SaleConfirmation />
      </div>
    </div>
  );
};

export default CheckoutConfirmSaleStep;
